import React from 'react'
import { Route, Switch } from 'react-router-dom'

// styles
import 'bootstrap/dist/css/bootstrap.css';
import './stylesheets/base.scss'


// Components
import Header from './components/Header'

import Footer from './components/Footer'
import PageNotFound from './components/PageNotFound'


// Containers
import Home from './containers/Home'
import ProjectDetail from './containers/ProjectDetail'
import Solutions from './containers/Solutions'
import ProjectOverview from './containers/ProjectOverview'
import Services from './containers/Services'
import Market from './containers/Market'
import Certifications from './containers/Company/Certifications'
import AboutUs from './containers/Company/AboutUs'
import Gallery from './containers/Company/Gallery'
import ContactUs from './containers/ContactUs'
import Newsletter from './containers/Company/Newsletter'
import CaseStudy from './containers/Company/CaseStudy'
import GetQuote from './containers/Company/GetQuote';

const App = () => {
  return (
    <div className="eidim-app">
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />

        <Route path="/services/:section" component={Services} />
        <Route path="/services/" component={Services} />

        <Route path="/solutions/:section" component={Solutions} />
        <Route path="/solutions" component={Solutions} />

        <Route path="/market" component={Market} exact />
        <Route path="/market/:category" component={ProjectOverview} exact />
        <Route path="/market/:category/:url" component={ProjectDetail} exact />

        <Route path="/company/certifications-licenses" component={Certifications} />
        <Route path="/company/about-us" component={AboutUs} />
        <Route path="/company/gallery" component={Gallery} />
        <Route path="/company/newsletter" component={Newsletter} />
        <Route path="/company/case-study" component={CaseStudy} />
        <Route path="/company/get-a-quote" component={GetQuote} />


        <Route path="/contact-us" component={ContactUs} />

        <Route component={PageNotFound} />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
